import * as React from 'react'
import { GeneralModuleProps } from './types'
import { ModuleCard } from '../../components/ModuleCard'
import { IconName } from '@petz/ds-icon/dist/Icon/types'

export const GeneralModule: React.FC<GeneralModuleProps> = ({ sections }) => {
  return (
    <>
      {sections && sections.length > 0 ? (
        <div>
          {sections.map((element) => {
            return (
              <ModuleCard
                key={element.id}
                icon={element.icon as IconName}
                id={element.id}
                isAvailable={element.isAvailable}
                title={element.title}
                isAvailableText={element.isAvailableText}
                notAvailableText={element.notAvailableText}
              />
            )
          })}
        </div>
      ) : null}
    </>
  )
}
